module.exports = __webpack_public_path__ + "static/media/login.15e68955.svg";